export enum TipoInstrucaoBoletoEnum {
  Normal = "normal",
  Acordo = "acordo",
}
